// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2k9QE","row":"ProcedureTreatmentSummary_row__2UAAg"};